
import Vue from 'vue'
import ASCAArtIncLink from "./ASCAArtIncLink.vue";
import BylawsLink from "./BylawsLink.vue";

export default Vue.extend({
  name: 'LitterSignature',
  components: { ASCAArtIncLink, BylawsLink }
});
